module.exports = __webpack_public_path__ + "static/media/burdock.708bb5aa.jpg";